/**
 * Parses forecast slot datetime from API ("Y-m-d H:00") as local wall-clock time.
 * Avoids Date/toISOString UTC shift that misplaces 00–03h on the previous day.
 */
export function parseForecastDatetime(datetime) {
    const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):00$/.exec(String(datetime || "").trim());
    if (!match) {
        return null;
    }
    const [, year, month, day, hour] = match;
    return {
        dayKey: `${year}-${month}-${day}`,
        hourKey: hour,
        sortKey: `${year}-${month}-${day}T${hour}`,
    };
}

export function buildForecastTable(timeline) {
    if (!Array.isArray(timeline) || timeline.length === 0) {
        return null;
    }

    const parsed = timeline
        .map((item) => {
            const parts = parseForecastDatetime(item?.datetime);
            if (!parts) {
                return null;
            }
            return { ...item, ...parts };
        })
        .filter(Boolean)
        .sort((a, b) => a.sortKey.localeCompare(b.sortKey));

    if (!parsed.length) {
        return null;
    }

    const dayKeys = [];
    parsed.forEach((item) => {
        if (!dayKeys.includes(item.dayKey)) {
            dayKeys.push(item.dayKey);
        }
    });

    const hours = Array.from({ length: 24 }, (_, idx) => String(idx).padStart(2, "0"));
    const map = {};
    parsed.forEach((item) => {
        map[`${item.dayKey}_${item.hourKey}`] = item;
    });

    return { dayKeys, hours, map };
}
